import { BlockUi } from './../../auth/_helpers/block-ui';
import { User } from './../../auth/_models/user';
import { VaccineService } from './../../auth/_services/vaccine.service';
import { ActivatedRoute } from '@angular/router';
import { Breed } from './../../auth/_models/breed';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { Pet } from 'src/app/auth/_models/pet';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { AuthenticationService } from './../../_services/authentication.service';

declare let CustomScript: any;
declare let $: any;

@Component({
  selector: 'app-pet-detail-vaccine-insert',
  templateUrl: './pet-detail-vaccine-insert.component.html',
  styleUrls: ['./pet-detail-vaccine-insert.component.css'],
  providers: [VaccineService]
})
export class PetDetailVaccineInsertComponent implements OnInit, AfterViewInit {

  formVaccination: FormGroup;

  user: User;

  pet: Pet;

  genderList: any[] = ['Macho', 'Fêmea'];

  species: any[] = ['Canino', 'Felino'];

  breeds;

  vaccines;

  constructor(
    private _formBuilder: FormBuilder,
    private _blockui: BlockUi,
    private _petsService: PetsService,
    private _authService: AuthenticationService,
    private _vaccineService: VaccineService,
    private _route: ActivatedRoute) {
    this.user = new User();
    this.pet = new Pet();
    this.formVaccination = _formBuilder.group({
      vaccine: [null, [Validators.required]],
      notes: [null],
      dosageVaccine: [null, [Validators.required]],
      boosterShot: [null],
      vetName: [null, [Validators.required]],
      alert: [null],
      alerttype: [null],
    });
  }

  ngOnInit() {
    this._route.parent.params.subscribe(params => {
      const uuid = params['id'];
      this._petsService
        .getPet(uuid)
        .valueChanges()
        .subscribe(p => {

          p.uuid = uuid;

          if (p.birthday) {
            if (typeof p.birthday.toDate === 'function') {
              p.birthday = p.birthday.toDate();
            }
          }

          this.pet = p;

        });
    });

    this._vaccineService.getVaccines().subscribe(vaccines => {
      this.vaccines = vaccines;
      CustomScript.updateUniform();
    });

  }

  selectSpecies(specie: string) {
    this.breeds = new Array();
    const _breeds = this.breeds;

    this._petsService.getBreeds(specie.toLowerCase())
      .then((data) => {

        data.forEach(item => {
          _breeds.push(new Breed({ uuid: item.id, ...item.data() }));
        });

      }).catch(error => {
        console.log(error);
      });

  }

  getControl(field: string): AbstractControl {
    return this.formVaccination.get(field);
  }

  verificaValidTouched(field: string) {
    return (
      !this.getControl(field).valid &&
      (this.getControl(field).touched || this.getControl(field).dirty)
    );
  }

  checkValid(control) {
    return {
      'border-danger': this.verificaValidTouched(control)
    };
  }

  ngAfterViewInit(): void {
    CustomScript.initUniform();
    CustomScript.initSwitchery();
  }

  onSubmit() {
    if (this.formVaccination.valid) {
      this._blockui.block();
      const user = this.user;
      const controls = this.formVaccination.controls;
      this._vaccineService.newVaccination(this.pet,
        {
          primary_shot_date: new Date(),
          booster_shot_date: new Date(controls.boosterShot.value),
          dosage: controls.dosageVaccine.value,
          pet: JSON.parse(JSON.stringify(this.pet)),
          // user: JSON.parse(JSON.stringify(user)),
          vetName: controls.vetName.value,
          vaccine: JSON.parse(JSON.stringify(controls.vaccine.value)),
          notes: controls.notes.value,
          alert: controls.alert.value,
          alerttype: controls.alerttype.value,
        })
        .then(ok => {
          this._blockui.unblock();
          this.formVaccination.reset();
          this._authService.redirect();
        })
        .catch(error => {
          this._blockui.unblock();
          this.formVaccination.reset();
        });
    }
  }

  save_alert(event) {
    if (event.target.checked) {
      $('.alerttypediv').show();
    } else {
      $('.alerttypediv').hide();
    }
  }
}
